
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 11.241h5.143l-3.429 6.857h5.143l3.429-6.857V.956H0V11.24zM13.715.956V11.24h5.143l-3.429 6.857h5.143L24 11.241V.956H13.715z","fill":"#545C69"}})])
          )
        }
      }
    